import { Group } from '../../../../redux/groups/api/group.model';

export enum GroupType {
  Store = 'STORE',
  Company = 'COMPANY',
}

export interface SCCGroupInfo extends Group {
  attributes: {
    BUSINESS_ROLE: GroupType;
    [key: string]: string;
    contacts: string; // stringify of {name:string,email:string, phone:string}[]
  };
}
